import { put, select, call, takeEvery, takeLatest, take } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { LAUNCH_QUESTIONNAIRE, SUBMIT_QUESTIONNAIRE, questionnaireSelectors } from '../reducer/questionnaire-reducer';
import { authSelectors } from '@rosetta/react-auth';
import { saveQuestionnaireData } from '../services/questionnaire-helpers';
import { GET_LEARNER_CONFIGS, questionnaireActions } from '../reducer/questionnaire-reducer';
import { appSelectors, SET_APP_INITIALIZED } from '../../app/reducer/app-reducer';
import { fetchLearnerConfigs } from '../../launchpad/services/ego-api';

export function* launchQuestionnaireSaga(action) {
  yield put(push('/objectives/questions'));
}

export function* submitQuestionnaireSaga(action) {
  const authToken = yield select(authSelectors.authToken);
  const activityId = yield select(questionnaireSelectors.getActivityId);
  try {
    yield call(saveQuestionnaireData, action.payload, activityId, authToken);
  } catch (ex) {
    // go to error page
    yield put(push('launchpad/error'));
  }
  yield put(questionnaireActions.resetQuestionnaire());
  yield put(push('/launchpad'));
}

function* getLearnerConfigs() {
  const isAppInitialized = yield select(appSelectors.isAppInitialized);
  if (!isAppInitialized) {
    yield take(SET_APP_INITIALIZED); // wait until app is initialized
  }
  const user = yield select(authSelectors.userInfo);

  const authToken = yield select(authSelectors.authToken);

  if (user) {
    const learnerConfigs = yield call(fetchLearnerConfigs, user.organization, authToken);
    yield put(questionnaireActions.setLearnerConfigs(learnerConfigs));
  }
}

export function* questionnaireSagas() {
  yield takeEvery(LAUNCH_QUESTIONNAIRE, launchQuestionnaireSaga);
  yield takeEvery(SUBMIT_QUESTIONNAIRE, submitQuestionnaireSaga);
  yield takeLatest(GET_LEARNER_CONFIGS, getLearnerConfigs);
}



// WEBPACK FOOTER //
// ./src/modules/questionnaire/sagas/questionnaire-sagas.js